/* eslint-disable @typescript-eslint/no-explicit-any */
import {Typography, Box, Grid, Link} from '@mui/material';
import {Image} from '@jobseeker/lotus/components/Image';
import {useState} from 'react';
import useLoadAds from '@jobseeker/common-core/hooks/useLoadAds';
import Divider from '@jobseeker/lotus/components/Divider';

import type {AdElement} from '../../types';

const VerticalFrame = ({slot, label}: AdElement) => {
  const [employers, setEmployers] = useState([]);
  useLoadAds(slot, setEmployers);

  return (
    <Box>
      <Typography
        component={'span'}
        fontSize={18}
        fontWeight={600}
        color="gray.dark"
      >
        {label}
      </Typography>
      <Divider
        sx={{
          margin: '10px 0 !important',
          border: '0.5px solid #ddd !important',
        }}
      />
      <Grid container spacing={1}>
        {employers?.map((data: any, i: number) => (
          <Grid item md={6} key={`ads-v1-employer-${i}`}>
            <Box sx={{display: 'flex'}}>
              <Box sx={{pr: 1.5}}>
                <Image
                  src={data.companyLogo || data.imageUrl}
                  alt={data.title}
                  width="20"
                  height={'20'}
                  objectFit="cover"
                  quality={50}
                  placeholder="blur"
                  blurDataURL={data.companyLogo || data.imageUrl}
                />
              </Box>
              <Link
                title={data.title}
                href="#"
                target="_blank"
                color="gray.dark"
                fontSize="13px"
                boxSizing="border-box"
                sx={{
                  overflowX: 'hidden',
                  overflowY: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  textDecoration: 'none',
                  cursor: 'pointer',
                  ':hover': {
                    textDecoration: 'underline',
                    color: 'secondary.main',
                  },
                }}
              >
                {data.title}
              </Link>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default VerticalFrame;
